import React from 'react';
import { Image as BuilderImage } from '@builder.io/react';
import { Link } from 'gatsby';

import { slugify } from '../../util/util';
import { FontAwesomeIcon } from "../../libs/fonts"

const JobBoardItem = ({ sponsor }) => {
  if (!sponsor?.jobBoard || sponsor.jobBoard === '<p><br></p>') {
    return <></>;
  }
  return (
    <div key={sponsor.id} className='blog-item pb-60'>
      <div className='blog-content row'>
        <div className='blog-meta-images col-lg-4 pr-20' style={{ display: 'flex', alignItems: 'center' }}>
          {sponsor.logo && (
            <img
              src={sponsor.logo}
              alt={`${sponsor.name}'s logo`}
              style={{ maxHeight: '100%', maxWidth: 400, minHeight: 100, minWidth: 200 }}
            />
          )}
        </div>

        <div className='col-lg-8'>
          <h3 className='blog-title mt-30 mb-0'>
            <Link to={`/sponsors/${slugify(sponsor.name)}`}>
              {sponsor.name}
            </Link>
          </h3>

          <ul className='social-icons mt-10' style={{ display: 'flex' }}>
            {sponsor.linkedIn && (
              <li className='mr-20'>
                <a href={sponsor.linkedIn} target='_blank' rel='noreferrer'>
                  <FontAwesomeIcon
                    icon={'fa-brands fa-linkedin'}
                    style={{ fontSize: 22, color: 'black' }}
                  />
                  <span style={{ display: 'none' }}>LinkedIn link</span>
                </a>
              </li>
            )}
            {sponsor.twitter && (
              <li className='mr-20'>
                <a href={sponsor.twitter} target='_blank' rel='noreferrer'>
                  <FontAwesomeIcon
                    icon={'fa-brands fa-x-twitter'}
                    style={{ fontSize: 22, color: 'black' }}
                  />
                  <span style={{ display: 'none' }}>X link</span>
                </a>
              </li>
            )}
            {sponsor.mastodon && (
              <li className='mr-20'>
                <a href={`https://mastodon.social/${sponsor.mastodon}`} target='_blank' rel='noreferrer'>
                  <FontAwesomeIcon
                    icon={`fa-brands fa-mastodon`}
                    style={{ fontSize: 22, color: 'black' }}
                  />
                  <span style={{ display: 'none' }}>Mastodon link</span>
                </a>
              </li>
            )}
            {sponsor.url && (
              <li className='mr-20'>
                <a href={sponsor.url} target='_blank' rel='noreferrer'>
                  <FontAwesomeIcon
                    icon={'fa-solid fa-link'}
                    style={{ fontSize: 20, color: 'black' }}
                  />
                  <span style={{ display: 'none' }}>Website link</span>
                </a>
              </li>
            )}
          </ul>

          <div
            className='desc margin-0 pt-30 pb-25 inner-html'
            style={{ listStyle: 'auto' }}
            dangerouslySetInnerHTML={{ __html: sponsor.jobBoard.replace('<p><br></p>', '') }}
          />
          {/* <div className='blog-button orange-btn'>
            <Link to={talk.path}>
              <span className='btn-txt'>Read More</span>
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default JobBoardItem;
